import { localNoCache } from "./axiousWithCache"

/** Element that opened the help aside (DOM; not Vuex state). */
let helpCenterOpenerElement = null

export function setHelpCenterOpenerElement(el) {
  const isHTMLElementAvailable = typeof HTMLElement !== "undefined"

  helpCenterOpenerElement =
    isHTMLElementAvailable && el instanceof HTMLElement ? el : null
}

export function takeHelpCenterOpenerElement() {
  const el = helpCenterOpenerElement
  helpCenterOpenerElement = null
  return el
}

const state = {
  isLoading: false,
  content: null
}

const mutations = {
  SET_CONTENT(state, content) {
    state.content = content
  },
  SET_IS_LOADING(state, isLoading) {
    state.isLoading = isLoading
  }
}

const getters = {
  getHelpCenterContent(state) {
    return state.content
  }
}
const actions = {
  getHelpCenterContent(context, { contentKey, locale = "en" }) {
    const filePathMapping = {
      es: "/helpCenter/spanish/",
      en: "/helpCenter/"
    }

    const fallbackLocale = "en"

    const rootFilePath = filePathMapping[locale] || "/helpCenter/"

    const filePath = rootFilePath + contentKey + ".html"

    context.commit("SET_IS_LOADING", true)
    localNoCache
      .get(filePath)
      .then((res) => {
        if (res.data) {
          context.commit("SET_CONTENT", res.data)
        } else {
          // Fallback to English if localized content doesn't exist
          if (locale !== fallbackLocale) {
            context.dispatch("getHelpCenterContent", {
              contentKey,
              locale: fallbackLocale
            })
          } else {
            context.commit("SET_CONTENT", "No Information or this key")
          }
        }
      })
      .catch((err) => {
        context.commit("SET_CONTENT", err)
      })
      .finally(() => {
        context.commit("SET_IS_LOADING", false)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
